module.exports = __webpack_public_path__ + "static/12-754d3a969111020d49c1128a905738a1.svg";